import FilterDrawer from 'components/People/FilterDrawer';
import SyncRosterDialog from 'components/People/SyncRosterDialog';
import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/People/desktop';
import Mobile from 'pages/People/mobile';
import { PageContext } from 'pages/People/PageProvider';
import Tablet from 'pages/People/tablet';
import { useContext } from 'react';
import { Loading } from 'shell/components';

const PageLayout = () => {
    const { isLoading } = useApp();
    const { device } = useViewport();

    const props = useContext(PageContext);

    const renderResponsiveLayouts = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    return isLoading ? (
        <Loading />
    ) : (
        <>
            {renderResponsiveLayouts(device)}
            <FilterDrawer
                columns={props.columns}
                sortState={props.sortState}
                handleSetSortState={props.handleSetSortState}
            />
            <SyncRosterDialog
                open={props.syncRosterDialog.open}
                onClose={() => props.setSyncRosterDialog({ open: false })}
            />
        </>
    );
};

export default PageLayout;
